module.exports = __webpack_public_path__ + "img/i-photo.ee7da98c.svg";